export const vehicle = {
  AIFeature: "AI功能",
  alertSettings: "警示设置",
  pdAlertsDSSAlert: "驾驶行为警示",
  pdAlertsDSSFrontAlert: "前方警示",
  pdAlertsDSSLeftAlert: "左方警示",
  pdAlertsDSSRearAlert: "后方警示",
  pdAlertsDSSRightAlert: "右方警示",
  authorizedDrivers: "授权司机",
  primaryDetection: "主要边界",
  adaptiveDetection: "额外边界",
  available: "已安装",
  calibrated: "已校准",
  calibrationStatus: "校准状态",
  cameraInstallationHeight: "摄像头安装高度",
  criticalBoundaryDistance: "危险区边界距离",
  detectionFiledOfView: "侦测角度",
  deviceModel: "系统型号",
  DSS: "驾驶摄像头",
  Fatigue: "疲劳驾驶",
  firmware: "系统版本",
  fleet: "车间",
  department: "部门",
  Front: "前摄像头",
  Good: "正常",
  Left: "左摄像头",
  LessThanAMonth: "少于一个月",
  LessThanAWeek: "少于一周",
  max: "最大",
  notes: "备注",
  off: "关",
  on: "开",
  Phone: "使用电话",
  photo: "照片",
  Rear: "后摄像头",
  ReverseLightSensor: "倒车灯传感器",
  Right: "右摄像头",
  SeatBeltSensor: "安全带传感器",
  SeatBeltSensorBattery: "安全带传感器电池电量",
  sensors: "传感器",
  Smoking: "抽烟",
  SpeedSensor: "速度传感器",
  unAvailable: "未安装",
  uncalibrated: "未校准",
  vehicleID: "设备编号",
  vehicleModel: "型号",
  warningBoundaryDistance: "警示区边界距离",
  WiFiMode: "Wi-Fi模式",
  WiFiPassword: "Wi-Fi密码",
  WiFiSettings: "Wi-Fi设置",
  WiFiSSID: "Wi-Fi名称",
  warningZone: "警示区",
  criticalZone: "危险区",
  SpeedSensorBattery: "速度传感器电池电量",
  SpeedSensorInstallationPosition: "速度传感器安装位置",
  TireLeft: "轮胎左侧",
  TireRight: "轮胎右侧",
  storage: "容量",
  SDCard: "SD卡",
  SDCardNotFound: "未识别",
  lowBattery: "电池电量低",
  low: "低",
  AiFeatureTips: "（警示设置在摄像头校准后才会生效）",
  accessory: "配件",
  unConnected: "未连接",
  driveTrainType: "驱动",
  maintenanceRemind: "保养到期",
  vehicleCheckDue: "车检到期",
  vehicleCheckPhoto: "车检照片",
  detectionLeftDegree: "摄像头左侧角度",
  detectionRightDegree: "摄像头右侧角度",
  frontRightCamera: "右前摄像头",
  rearRightCamera: "右后摄像头",
  cam1: "摄像头1",
  cam2: "摄像头2",
  detectionSensitivity: "侦测灵敏度",
};
